/**
 * Flick The Switch - Theme JavaScript
 * Clean, minimal interactions for a gallery aesthetic
 */

(function() {
  'use strict';

  // =============================================
  // Mobile Navigation
  // =============================================
  const mobileMenuToggle = document.getElementById('mobile-menu-toggle');
  const mainNav = document.getElementById('main-nav');
  const navClose = document.getElementById('nav-close');
  const mobileOverlay = document.getElementById('mobile-overlay');

  function openMobileMenu() {
    mainNav?.classList.add('is-open');
    mobileOverlay?.classList.add('is-visible');
    mobileMenuToggle?.setAttribute('aria-expanded', 'true');
    document.body.classList.add('no-scroll');
  }

  function closeMobileMenu() {
    mainNav?.classList.remove('is-open');
    mobileOverlay?.classList.remove('is-visible');
    mobileMenuToggle?.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('no-scroll');
  }

  mobileMenuToggle?.addEventListener('click', openMobileMenu);
  navClose?.addEventListener('click', closeMobileMenu);
  mobileOverlay?.addEventListener('click', closeMobileMenu);

  // Close on escape key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeMobileMenu();
    }
  });

  // =============================================
  // Hero Slideshow
  // =============================================
  const heroSlides = document.querySelectorAll('.hero__slide');
  const heroDots = document.querySelectorAll('.hero__dot');
  let currentSlide = 0;
  let slideInterval;

  function goToSlide(index) {
    heroSlides.forEach((slide, i) => {
      slide.classList.toggle('is-active', i === index);
    });
    heroDots.forEach((dot, i) => {
      dot.classList.toggle('is-active', i === index);
      dot.setAttribute('aria-selected', i === index ? 'true' : 'false');
    });
    currentSlide = index;
  }

  function nextSlide() {
    const next = (currentSlide + 1) % heroSlides.length;
    goToSlide(next);
  }

  function startSlideshow() {
    if (heroSlides.length > 1) {
      // Get autoplay speed from section settings (default 5 seconds)
      const speed = 5000;
      slideInterval = setInterval(nextSlide, speed);
    }
  }

  function stopSlideshow() {
    clearInterval(slideInterval);
  }

  // Initialize slideshow
  if (heroSlides.length > 1) {
    startSlideshow();

    // Dot navigation
    heroDots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        stopSlideshow();
        goToSlide(index);
        startSlideshow();
      });
    });

    // Pause on hover
    const hero = document.querySelector('.hero');
    hero?.addEventListener('mouseenter', stopSlideshow);
    hero?.addEventListener('mouseleave', startSlideshow);
  }

  // =============================================
  // Product Gallery
  // =============================================
  const productThumbs = document.querySelectorAll('.product-gallery__thumb');
  const mainProductImage = document.getElementById('main-product-image');

  productThumbs.forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const imageUrl = thumb.dataset.imageUrl;
      if (mainProductImage && imageUrl) {
        mainProductImage.src = imageUrl;
        productThumbs.forEach((t) => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
      }
    });
  });

  // =============================================
  // Scroll Animations
  // =============================================
  const animateOnScroll = () => {
    const elements = document.querySelectorAll('.stagger-children > *');

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.style.animationPlayState = 'running';
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    });

    elements.forEach((el) => {
      el.style.animationPlayState = 'paused';
      observer.observe(el);
    });
  };

  // Initialize scroll animations after page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', animateOnScroll);
  } else {
    animateOnScroll();
  }

  // =============================================
  // Sticky Header Shadow
  // =============================================
  const header = document.querySelector('.site-header');

  if (header) {
    let lastScroll = 0;

    window.addEventListener('scroll', () => {
      const currentScroll = window.pageYOffset;

      if (currentScroll > 100) {
        header.style.boxShadow = 'var(--shadow-base)';
      } else {
        header.style.boxShadow = 'none';
      }

      lastScroll = currentScroll;
    }, { passive: true });
  }

  // =============================================
  // Smooth Scroll for Anchor Links
  // =============================================
  document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
    anchor.addEventListener('click', function(e) {
      const href = this.getAttribute('href');
      if (href !== '#' && href !== '#main') {
        e.preventDefault();
        const target = document.querySelector(href);
        if (target) {
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      }
    });
  });

  // =============================================
  // Form Validation Enhancement
  // =============================================
  const forms = document.querySelectorAll('form');

  forms.forEach((form) => {
    const inputs = form.querySelectorAll('input[required], textarea[required]');

    inputs.forEach((input) => {
      input.addEventListener('blur', () => {
        if (input.value.trim() === '') {
          input.classList.add('is-invalid');
        } else {
          input.classList.remove('is-invalid');
        }
      });

      input.addEventListener('input', () => {
        if (input.classList.contains('is-invalid') && input.value.trim() !== '') {
          input.classList.remove('is-invalid');
        }
      });
    });
  });

  // =============================================
  // Lazy Load Images (Native)
  // =============================================
  if ('loading' in HTMLImageElement.prototype) {
    const lazyImages = document.querySelectorAll('img[loading="lazy"]');
    lazyImages.forEach((img) => {
      if (img.dataset.src) {
        img.src = img.dataset.src;
      }
    });
  }

  // =============================================
  // Cart Count Update (for AJAX cart)
  // =============================================
  window.updateCartCount = function(count) {
    const cartCounts = document.querySelectorAll('.cart-count');
    cartCounts.forEach((el) => {
      if (count > 0) {
        el.textContent = count;
        el.style.display = '';
      } else {
        el.textContent = '';
        el.style.display = 'none';
      }
    });
  };

  // =============================================
  // YouTube Facade (Lite Embed)
  // =============================================
  document.querySelectorAll('.youtube-facade').forEach((facade) => {
    facade.addEventListener('click', function() {
      const videoId = this.dataset.youtubeId;
      if (!videoId) return;

      const iframe = document.createElement('iframe');
      iframe.src = `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&modestbranding=1`;
      iframe.title = 'YouTube video';
      iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
      iframe.allowFullscreen = true;

      // Replace facade content with iframe
      this.innerHTML = '';
      this.appendChild(iframe);
      this.style.cursor = 'default';
    });
  });

})();
